import dayjs from 'dayjs';
import 'dayjs/locale/id';

dayjs.locale('id');

export default dayjs;
